/* import __COLOCATED_TEMPLATE__ from './trigger.hbs'; */
import Component from '@ember/component';
export default class Trigger extends Component {}